// @flow
import {i18nReducer, MODULE_NAME} from '@userstory/i18n';
import {AUTH_MODULE_NAME} from 'modules/auth/constants';
import {authReducer} from 'modules/auth/reducers/auth';
import {CENTRIFUGE_MODULE_NAME} from 'modules/centrifuge/constants';
import {centrifugeReducer} from 'modules/centrifuge/reducers';
import {DASHBOARD_MODULE_NAME} from 'modules/dashboard/constants';
import {dashboardReducer} from 'modules/dashboard/reducers';
import {LICENSE_MODULE_NAME} from 'modules/license/constants';
import {licenseReducers} from 'modules/license/reducers';
import {SETTINGS_MODULE_NAME} from 'modules/settings/constants';
import {settingsReducer} from 'modules/settings/reducers';
import {TRAINING_MODULES_MODULE_NAME} from 'modules/trainingModules/constants';
import {trainingModulesReducer} from 'modules/trainingModules/reducers';
import {USER_MODULE_NAME} from 'modules/user/constants';
import {userReducers} from 'modules/user/reducers';
import {combineReducers} from 'redux';

export const rootReducer = combineReducers({
    [AUTH_MODULE_NAME]: authReducer,
    [CENTRIFUGE_MODULE_NAME]: centrifugeReducer,
    [DASHBOARD_MODULE_NAME]: dashboardReducer,
    [LICENSE_MODULE_NAME]: licenseReducers,
    [MODULE_NAME]: i18nReducer,
    [SETTINGS_MODULE_NAME]: settingsReducer,
    [TRAINING_MODULES_MODULE_NAME]: trainingModulesReducer,
    [USER_MODULE_NAME]: userReducers,
});
